module.exports = __webpack_public_path__ + "media/images/mailer/activation_customer/png/startpage_de-81cd429e7e3c11b2610d2da455f4aa3a.png";